import styled from 'styled-components';

import rem from 'polished/lib/helpers/rem';

import spacing from '@decisiv/design-tokens/lib/spacing';

export const IconContainer = styled.div`
  min-width: ${rem(spacing.base * 1.6)};
`;
